// extracted by mini-css-extract-plugin
export default {"outerContainer":"OurPlatformFourCards_outerContainer__I9pmO","heading":"OurPlatformFourCards_heading__zgZeb","cardsGrid":"OurPlatformFourCards_cardsGrid__KBTaB"};